import { CONTACT_NETWORK_PROFILES, CONTACT_NETWORK_TYPE, CONTROLLER_CONSTANTS, LEAD_TYPES } from '@/utils/constants';
import {
    capitalizeFilter,
    currencyFilter,
    monthYearFilter,
    networkContactFilter,
    cardTypeFilter,
    dateFilter,
    numberFilter,
    snakeCaseFilter,
    cnpjFilter
} from '@/utils/filters';

import GridDetails from './grid-details/';
export default {
    name: 'MultipleContactsDetails',
    components: {
        GridDetails
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '800px'
        },
        height: {
            type: String,
            default: 'auto'
        },
        selectedContact: {
            type: Object,
            default: () => {
                return {};
            }
        },
        subscription: {
            type: Object,
            default: () => {
                return {};
            }
        },
        isSupplier: {
            type: Boolean,
            default: false
        },
        contactAdquired: {
            type: Boolean,
            default: false
        },
        contactVisualized: {
            type: Boolean,
            default: false
        },
        subscriptionEngelinkCash: {
            type: Number,
            default: 0
        },
        subscriptionBonusCash: {
            type: Number,
            default: 0
        },
        hasSubscription: {
            type: Boolean,
            default: false
        },
        disableButton: {
            type: Boolean,
            default: false
        },
        contactFilters: {
            type: Array,
            default: []
        },
        isQualifiedContactsFilterSelected: {
            type: Boolean,
            default: false
        },
        isProContactsFilterSelected: {
            type: Boolean,
            default: false
        },
        multipleContactsGrid: {
            type: Object,
            default: () => {
                return {};
            }
        },
        selectedContactsTotal: {
            type: Number,
            default: 0
        },
        selectedContactsTotalPrice: {
            type: Number,
            default: 0
        },
        hasMoreProContactsSelectedThanFreeBalance: {
            type: Boolean,
            default: false
        },
        hasMoreQualifiedContactsSelectedThanFreeBalance: {
            type: Boolean,
            default: false
        },
        hasSubtotalMixedPayment: {
            type: Boolean,
            default: false
        },
        hasSubtotalBonus: {
            type: Boolean,
            default: false
        },
        hasSubtotalBalance: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            censoredField: '*******',
            CONTACT_NETWORK_PROFILES: CONTACT_NETWORK_PROFILES,
            CONTACT_NETWORK_TYPE: CONTACT_NETWORK_TYPE,
            CONTROLLER_CONSTANTS: CONTROLLER_CONSTANTS,
            LEAD_TYPES: LEAD_TYPES,
            logoBasePath: 'https://static.app.staging.engelink.com.br/static-contact-network/'
        };
    },
    methods: {
        capitalizeFilter,
        currencyFilter,
        monthYearFilter,
        networkContactFilter,
        cardTypeFilter,
        dateFilter,
        numberFilter,
        snakeCaseFilter,
        cnpjFilter,
        openMultipleContactsCreditPaymentModal() {
            this.$emit('openMultipleContactsCreditPaymentModal');
        },
        openMultipleContactsMixedPaymentModal() {
            // abrir o modal de mixed multiplo
        },
        openMultipleContactsBonusPaymentModal() {
            this.$emit('openMultipleContactsBonusPaymentModal');
        },
        openMultipleContactsEngelinkCashPaymentModal() {
            this.$emit('openMultipleContactsEngelinkCashPaymentModal');
        },
        adquireSelectedContacts(leadsTypes) {
            this.$emit('adquireSelectedContacts', leadsTypes);
        }
    },
    computed: {
        questionsAnswersAnswerOnly() {
            return this.selectedContact.questionsAnswers && this.selectedContact.questionsAnswers.length
                ? this.selectedContact.questionsAnswers.filter(data => data.answer)
                : [];
        }
    }
};
